import { PayloadAction } from '@reduxjs/toolkit';

import { ModalState } from './reducer';

export const toggleModal = (state: ModalState, action: PayloadAction<boolean>) => {
  state.value = action.payload
};
